export const EditRequestType = Object.freeze({
  ACCEPTED: 'accepted',
  REJECTED: 'rejected'
});
